import { IconButton, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { Icon } from '@/components/Icon/Icon';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import { TaxInfoTooltipContent } from './TaxInfoTooltipContent';

export function TaxInfoDrawerInfoButton() {
  const { t } = useTranslate();

  return (
    <Tooltip
      title={<TaxInfoTooltipContent />}
      placement="bottom"
      arrow
      slotProps={{
        tooltip: {
          sx: { maxWidth: 320 },
        },
      }}
    >
      <IconButton
        {...getDataTestId('tax-info-drawer-info-button')}
        aria-label={t('taxInfoDrawer.tooltip.ariaLabel')}
        size="small"
      >
        <Icon
          name="info-outline"
          color={(theme: Theme) => theme.palette.neutral[700]}
        />
      </IconButton>
    </Tooltip>
  );
}
